import {BaseColumn, BaseColumnConfig} from './base-column.model';

export class AvatarColumn extends BaseColumn {

  constructor(title: string,
              config: AvatarColumnConfig) {
    super(title,
      {
        property: config.property,
      });
    this._columnType = 'AvatarColumn';
  }

  get(element: any): any {
    return element[this.property][0];
  }
}

export interface AvatarColumnConfig extends BaseColumnConfig {
}
